import { storiesOf } from '@storybook/vue';
import { withKnobs, boolean, number, text } from '@storybook/addon-knobs';
import { EventBus } from '@/main/eventBus';
import { PageMode } from '@/main/utils/pageMode';

const stories = storiesOf('Components/DMS/Form', module);

stories
	.addDecorator(withKnobs)
	.add('Time Picker', () => ({
		template: `
		<dms-form :model="$data" :rules="rules">
			<dms-time-picker validationProperty="value" :value.sync="value" v-bind="$props" />
		</dms-form>
		`,
		data() {
			return {
				value: '',
			};
		},
		props: {
			label: {
				default: text('Label', 'Začátek události'),
			},
			placeholder: {
				default: text('Placeholder', 'Zvolte čas...'),
			},
			span: {
				default: number('Velikost v gridu', 12),
			},
			isRequired: {
				default: boolean('Povinné pole', true),
			},
			disabled: {
				default: boolean('Disabled', false),
			},
		},
		computed: {
			rules() {
				return {
					value: [
						{
							required: this.isRequired, trigger: ['change', 'blur'],
						},
					],
				};
			},
		},
		mounted() {
			EventBus.$emit('Mode', PageMode.EDIT);
		},
	}));
